import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import * as Auth from '../redux/AuthRedux'
import {useFormik} from 'formik'
import {otpLogin, resentOtpCode} from '../redux/AuthCRUD'
import { UserModel } from '../models/UserModel'
import { shallowEqual } from 'react-redux'
import { RootState } from '../../../../setup'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'

const initialValues = {
  code: '',
}

const otpSchema = Yup.object().shape({
  code: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Code is required'),
})

export function OtpLogin() {
  const [loading, setLoading] = useState(false)
  const [resending ,setResending] = useState(false);

  const dispatch = useDispatch()
  const intl = useIntl()

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [resendCode, setResendCode] = useState<boolean>(false)
  const formik = useFormik({
    initialValues,
    validationSchema: otpSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setResendCode(false);
      setHasErrors(undefined)
      const body = {userid: user?.saltid, otpcode: values.code};
      if (user) {
        otpLogin(body)
          .then((res) => {
            const {data} = res;
            if (data.code === 1) {
              setHasErrors(false)
              setLoading(false)
              dispatch(Auth.actions.setSessionId(user.apipw));
            } else {
              setHasErrors(true)
              setLoading(false)
              setSubmitting(false)
              setStatus('The login detail is incorrect')
            }
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      } else {
        setHasErrors(true)
        setLoading(false)
        setSubmitting(false)
      }
    },
  })

  const handelResendCode = () => {
    setResending(true);
    setHasErrors(undefined)
    setResendCode(false);
    const body = {userid: user?.saltid, instance: user?.systemid, username: user.login};
    if (user) {
      resentOtpCode(body)
        .then((res) => {
          const {data} = res;
          if (data.code === 1) {
            setResendCode(true)
            setResending(false)
          } else {
            setResendCode(false)
            setResending(false)
          }
        })
        .catch(() => {
          setResendCode(false)
          setResending(false)
        })
    } else {
      setResendCode(false)
      setResending(false)
    }
  }

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>{intl.formatMessage({ id: 'AUTH.CODE' })}</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'> {intl.formatMessage({ id: 'AUTH.ENTER.CODE' })}</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
            {intl.formatMessage({ id: 'AUTH.INVAOID.CODE' })}
            </div>
          </div>
        )}

        {resendCode === true && (
          <div className='mb-10 bg-light-info p-8 rounded'>
             <div className='text-info'>{intl.formatMessage({ id: 'AUTH.SENT.OTP.CODE' })}</div>
          </div>
        )}
        
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          {/* <label className='form-label fw-bolder text-gray-900 fs-6'>code</label> */}
          <input
            type='text'
            placeholder='Type the code we sent you'
            autoComplete='off'
            {...formik.getFieldProps('code')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.code && formik.errors.code},
              {
                'is-valid': formik.touched.code && !formik.errors.code,
              }
            )}
          />
          {formik.touched.code && formik.errors.code && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.code}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex  justify-content-center pb-lg-0' style={{flexDirection: 'column'}}>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder'
            disabled={formik.isSubmitting || !formik.isValid || user === undefined || loading}
          >
            {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'AUTH.SUBMIT' })}</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                {intl.formatMessage({ id: 'MENU.WAIT' })}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        <div className='d-flex  justify-content-center pb-lg-0 mt-2' style={{flexDirection: 'column'}} >
          <button
            type='button'
            className='btn btn-lg  btn-light-primary fw-bolder'
            disabled={user === undefined || resending}
            onClick={handelResendCode}
          >
            {!resending && <span className='indicator-label'>{intl.formatMessage({ id: 'AUTH.RESEND.CODE' })}</span>}
            {resending && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                {intl.formatMessage({ id: 'MENU.WAIT' })}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        <div className='d-flex  justify-content-end pb-lg-0 mt-2'>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-primary fw-bolder'
            >
              {intl.formatMessage({ id: 'AUTH.BACK' })}
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
